<header class="main__content__header modal-header">
  <h2 class="modal-title">Mais Informações</h2>
  <a class="header__btn__close" (click)="activeModal.close(true)">
    <span aria-hidden="true">X</span>
  </a>
</header>
<main class="modal-body">
  <section>
    <span class="row">Corpo Clínico</span>
    <br>
    <ng-template #naoPossuiCorpoClinico>
      <div class="mx-2 content-aviso">
        Não foi possível localizar esta informação.
      </div>
    </ng-template>
    <section class="mx-2" *ngIf="corpoClinico && corpoClinico.length > 0 else naoPossuiCorpoClinico">
      <div class="content-aviso" *ngFor="let pessoa of corpoClinico">
        * {{pessoa | titlecase}}
      </div>
    </section>
    <div>
    </div>
  </section>
</main>